<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div v-if="ok">
          <validation-observer
            ref="observer"
            v-slot="{ invalid, handleSubmit }"
          >
            <b-form @submit.prevent="">
              <div class="form-card-wrapper">
                <b-card header-tag="header">
                  <template #header>
                    <b>Dati Generali</b>
                  </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].code.label"
                          vid="code"
                          label="Codice Agenzia Coass"
                          v-model="form[rep].code"
                          placeholder="Inserisci un codice agenzia"
                          :rules="getRules('code')"
                          :maxlength="getMaxLength('code')"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].code_importer.label"
                          vid="code_importer"
                          label="Codice Compagnia Coass"
                          v-model="form[rep].code_importer"
                          placeholder="Inserisci un codice compagnia"
                          :rules="getRules('code_importer')"
                          :maxlength="getMaxLength('code_importer')"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].title.label"
                          vid="title"
                          label="Ragione Sociale Intermediario Coass"
                          v-model="form[rep].title"
                          placeholder="Inserisci una ragione sociale"
                          :rules="getRules('title')"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].title_importer.label"
                          vid="title_importer"
                          :label="beForm[rep].title_importer.label"
                          v-model="form[rep].title_importer"
                          placeholder="Inserisci una compagnia"
                          :rules="getRules('title_importer')"
                        />
                      </div>
                      <div class="form-group">
                        <!-- #1172 -->
                        <base-currency
                          :name="beForm[rep].attribute_BONA_value.label"
                          vid="attribute_BONA_value"
                          :label="beForm[rep].attribute_BONA_value.label"
                          v-model="form[rep].attribute_BONA_value"
                          placeholder="Inserisci un addebito"
                          :options="{
                          currency: 'EUR',
                          locale: 'it-IT',
                          precision: 2,
                        }"
                          :rules="getRules('attribute_BONA_value')"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].attribute_CREG_value.label"
                          vid="attribute_CREG_value"
                          :label="beForm[rep].attribute_CREG_value.label"
                          v-model="form[rep].attribute_CREG_value"
                          placeholder="Inserisci una codice fiscale o PIVA"
                          :rules="getRules('attribute_CREG_value')"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].attribute_INNO_value.label"
                          vid="attribute_INNO_value"
                          :label="beForm[rep].attribute_INNO_value.label"
                          v-model="form[rep].attribute_INNO_value"
                          placeholder="Inserisci una descrizione ritenuta"
                          :rules="getRules('attribute_INNO_value')"
                        />
                      </div>
                      <div class="form-group">
                        <base-currency
                          :name="beForm[rep].attribute_WHT_value.label"
                          vid="attribute_WHT_value"
                          :label="beForm[rep].attribute_WHT_value.label"
                          v-model="form[rep].attribute_WHT_value"
                          :options="{
                          locale: 'it-IT',
                          currencyDisplay: 'percent',
                          precision: 2,
                        }"
                          placeholder="Inserisci ritenuta"
                          :rules="getRules('attribute_WHT_value')"
                        />
                      </div>
                      <!-- #1172 -->
                      <div class="form-group">
                        <base-input
                          vid="attribute_TKTP_value"
                          :name="beForm[rep].attribute_TKTP_value.label"
                          :label="beForm[rep].attribute_TKTP_value.label"
                          v-model="form[rep].attribute_TKTP_value"
                          placeholder="Inserisci una modalità di pagamento"
                          :rules="getRules('attribute_TKTP_value')"
                        />
                      </div>
                      <div class="form-group">
                        <!-- :name="beForm[rep].sector_id.label"
                        :label="beForm[rep].agencybook_type.label" -->
                        <base-select
                          vid="sector_id"
                          name="sector_id"
                          label="Conto collegato"
                          v-model="form[rep].sector_id"
                          :options="sectors"
                        />
                      </div>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>
              <div class="form-card-wrapper">
              <correspondence-form
                v-model="correspondence_form"
                :beECForm="beForm[cor]"
                :repository="cor"
                :coass="isCoass"
              >
              </correspondence-form></div>
              <div class="form-actions form-actions--sticky">
                <div class="inner-wrapper">
                  <div>
      <span
        :title="`${
          invalid
            ? 'Compila correttamente i campi per poter salvare'
            : 'Invia il form'
        }`"
      >
        <b-button
          @click="handleSubmit(onSubmit)"
          type="button"
          :disabled="invalid"
          variant="lisaweb"
          size="sm"
          :title="`${
            invalid
              ? 'Compila correttamente i campi per poter salvare'
              : 'Invia il form'
          }`"
        >
          Salva
        </b-button>
      </span>
                    <b-button
                      @click="resetForm()"
                      class="btn--transparent btn-reset"
                      type="button"
                      title="Pulisci tutti i campi e compila il form nuovamente"
                    >Reset
                    </b-button
                    >
                  </div>
                  <div>
                    <b-button
                      @click="goBack()"
                      class="btn--transparent"
                      type="button"
                      title="Torna alla pagina precedente"
                    >
                      <b-icon-chevron-double-left
                        font-scale="0.9"
                      ></b-icon-chevron-double-left
                      >
                      Torna indietro
                    </b-button
                    >
                  </div>
                </div>
              </div>
            </b-form>
          </validation-observer>
        </div>
        <div v-else>
          {{ errorMessage }}
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import BaseInput from "@/components/form/BaseInput";
import BaseCurrency from "@/components/form/BaseCurrency";
import BaseSelect from "@/components/form/BaseSelect";
import ShortcutMixin from "@/mixins/ShortcutMixin";
import FormMixin from "@/mixins/FormMixin";
import CorrespondenceForm from "@/components/form/CorrespondenceForm";
import AddresBookCorrespondenceMixin from "@/mixins/AddressBookCorrespondenceMixin";
import {mapGetters} from "vuex";

export default {
  mixins: [FormMixin, ShortcutMixin, AddresBookCorrespondenceMixin],
  data() {
    return {
      isCoass: true,
      repository: "insurer_participant",
      sectors: [],
      form: {
        defaultCountryName: "Italia",
        home_province: null,
        optHomeCountries: [],
        optHomeProvinces: [],
        optHomeCouncils: [],
        insurer_participant: {
          code: null,
          title: null,
          code_importer: null,
          title_importer: null,
          sector_id: null,
          attribute_BONA_value: null,
          attribute_CREG_value: null,
          attribute_INNO_value: null,
          attribute_WHT_value: null,
          attribute_TKTP_value: null,
        },
        correspondence: {
          status_correspondence: 0,
          attribute_ADDR_value: null,
          attribute_CITY_value: null,
          attribute_CITY2_value: null,
          attribute_NOR_value: null,
          attribute_NAME2_value: null,
          attribute_ZIPC_value: null,
          broker: {},
        },
      },
    };
  },
  components: {
    BaseInput,
    BaseCurrency,
    BaseSelect,
    CorrespondenceForm,
  },
  methods: {
    goBack() {
      if (this.returnUrl) {
        switch (this.returnUrl) {
          case "profile-insurer-participants-create":
            this.$router.push({
              name: "insurer_participants.create",
            });
            break;
          default:
            console.log(
              "No returnUrl set matched! Fallback to default back behavior."
            );
            this.$router.back();
            break;
        }
      } else {
        this.$router.back();
      }
    },
    getMaxLength(val) {
      if (!val) return;
      const {max} = this.getRules(val) || {};
      if (!max) return;
      return `${max}`;
    },
    onSubmit() {
      this.isLoading = true;
      this.store(this.repository)
        .then((response) => {
          let insurer_statement_id = response.data.data.id;
          let promises = [];
          promises.push(
            this.storeSection(this.cor, insurer_statement_id, this.repository)
          );
          Promise.all(promises)
            .then(() => {
              this.onSucess("Compagnia Coass");
              this.shortcut(
                "insurer_participants.index",
                null,
                null,
                "filterInsurerParticipants"
              );
              this.isLoading = false;
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
            });
        })
        .catch((error) => {
          this.onFailure(error);
        });
    },
    onSucess(resource) {
      this.$showSnackbar({
        preset: "success",
        text: `Azione completata: ${resource} creata`,
      });
    },
    onFailure(error) {
      let errMsg = this.$getErrorMessage(error);
      this.$showSnackbar({
        preset: "error",
        text: `${errMsg}`,
      });
      this.isLoading = false;
    },
    ...mapGetters("auth", [
      "countries",
      "provinces",
      "provinceByProvinceId",
      "countries",
      "provinces",
      "councils",
    ]),
    ...mapGetters("auth", {
      getSectors: "sectors",
    }),
  },
  beforeMount() {
    this.initCreateCorrespondencesForm();
  },
  mounted() {
    this.sectors = this.getSectors(); /* .filter(
      (sector) => sector.is_agency === "Y"
    ); */
  },
  created() {
    this.isLoading = true;
    const ip = this.fetchCreateForm(this.repository);
    const cr = this.fetchCreateForm(this.cor);
    Promise.all([cr, ip]).then(() => {
      this.isLoading = false;
    });
  },
  computed: {
    rep() {
      return this.repository;
    },
    cor() {
      return "correspondence";
    },
  },
};
</script>
